import DrawerButton from "components/form/DrawerButton";
import Title from "components/form/Title";
import DynamicPaymentgateway from "components/form/DynamicPayment";
import usePaymentGatewaySubmit from "hooks/PaymentgatewaySubmit";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";

const PaymentGatewayDrawer = ({ id }) => {
    const {
        dataInput,
        setDataInput,
        register,
        handleSubmit,
        onSubmit,
        errors,
        loading,
    } = usePaymentGatewaySubmit(id);

    return (
        <>
            <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50">
                <Title title="Edit Payment Gateway" />
            </div>

            <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="px-6 pt-8 pb-40">
                        <DynamicPaymentgateway
                            dataInput={dataInput}
                            setDataInput={setDataInput}
                            register={register}
                            errors={errors}
                        />
                    </div>

                    <DrawerButton
                        isSubmitting={loading}
                        id={id}
                        title="Update"
                    />
                </form>
            </Scrollbars>
        </>
    );
};

export default PaymentGatewayDrawer;
